import RMTable from 'components/customComponents/Controls/RMTable';
import NewProgressBar from 'components/main/Setup/Imaging/ImageManagementTask/Results/NewProgressBar';
import React, { useMemo } from 'react';
import { STORAGE_INFO_TASK_ID, tableHeader } from './constants';
import useStorageInfo from './hooks';

interface StorageInfoProps {
  selectedNodesIds: number[];
}
const StorageInfo = ({ selectedNodesIds }: StorageInfoProps) => {
  const jobId = STORAGE_INFO_TASK_ID;

  const { storageInfoResult, databaseSize, progress } = useStorageInfo({
    selectedNodesIds,
    jobId,
  });

  const distinctStorageInfoResults = storageInfoResult?.filter(
    (item, index, self) =>
      item.plateId !== null &&
      item.plateId !== undefined &&
      index ===
        self.findIndex(
          (t) => t.plateId === item.plateId && t.imageStoreName === item.imageStoreName,
        ),
  );

  const totalSpaceUsed = useMemo(() => {
    if (!distinctStorageInfoResults) {
      return 0;
    }
    return distinctStorageInfoResults.reduce(
      (accumulator, currentItem) => accumulator + (currentItem?.cumulativeFileSize || 0),
      0,
    );
  }, [distinctStorageInfoResults]);

  return (
    <div
      id="storageinfo-wrapper"
      data-testid="storageinfo-wrapper"
      className="h-[64vh] overflow-hidden flex flex-col"
    >
      <div id="storageinfo-top" data-testid="storageinfo-top" className="h-[3%]">
        <hr className="-ml-4 -mr-4 mt-0 mb-0 bg-gray-500 h-px" />
      </div>
      <div
        id="storageinfo-header"
        data-testid="storageinfo-header"
        className="flex h-[5%]"
      >
        <div
          id="storageinfo-totalspace"
          data-testid="storageinfo-totalspace"
          className="flex-grow-[0.5]"
        >
          Total Space Used : {totalSpaceUsed.toFixed(3)} MB
        </div>
        <div
          id="storageinfo-databasesize"
          data-testid="storageinfo-databasesize"
          className="flex-grow-[0.1]"
        >
          Rock Maker Database Size : {databaseSize}
        </div>
        <div
          id="storageinfo-progress-wrapper"
          data-testid="storageinfo-progress-wrapper"
          className="flex flex-row flex-grow-[3]"
        >
          {progress < 100 && (
            <NewProgressBar
              mainContainerClassName="flex flex-row w-[85%]"
              title={storageInfoResult[storageInfoResult.length - 1]?.name}
              progressBarContainerClass="w-full flex h-[7px] leading-none text-xs bg-[#E0E0E0] rounded-md mt-[7px]"
              currentProgress={progress}
              progressWidth={progress}
              showProgressDigits={true}
              showTitle={false}
              backgroundColor={progress === 100 ? '#4CAF50' : '#0000ffb8'}
            />
          )}
        </div>
      </div>
      <div
        id="storageinfo-tablecontainer"
        data-testid="storageinfo-tablecontainer"
        className="h-[92%] overflow-y-auto"
      >
        <RMTable
          columns={tableHeader}
          data={distinctStorageInfoResults ?? []}
          tableClass="w-full max-h-[100%]"
        />
      </div>
    </div>
  );
};

export default StorageInfo;
